export enum AnnotationType {
  Polygon = 'polygon',
  LineString = 'linestring',
  Point = 'point',
  Cone = 'cone',
}
